export enum TransitEvent {
  NEW_TRANSIT_TICKET_CREATED = 'transit_ticket_created',
  UPDATE_TRANSIT_TICKET = 'update_transit_ticket',
  CANCEL_TRANSIT_TICKET = 'cancel_transit_ticket',
  DELETED_TRANSIT_TICKET = 'deleted_transit_ticket',
  NEW_TRANSIT_NOTIFICATION = 'new_transit_notification',
}
